// KPI seti "Çerçeve" seçicisi (TODO-KPI-29): yayınlanmış çerçeveler (`GET /kpi/frameworks`) +
// "Çerçevesiz / Diğer". Set oluşturma modalı ve Set ayarları paneli ortak kullanır. Setin
// mevcut çerçevesi listede yoksa (yayından kalkmış / silinmiş) seçenek olarak korunur ve
// "(yayında değil)" eki alır — kaydetmeden değer kaybolmaz. Liste modül içinde önbelleklenir.

import { useEffect, useState } from "react";
import type { KpiFrameworkOption } from "@mahir/shared";
import { listKpiFrameworks } from "../../api/kpi";
import { KPI_COPY } from "../../lib/kpi-ui";
import { inputStyle } from "./kpi-form-styles";

let cache: Promise<KpiFrameworkOption[]> | null = null;
function loadFrameworks(): Promise<KpiFrameworkOption[]> {
  cache ??= listKpiFrameworks().catch((err: unknown) => {
    cache = null; // sonraki açılışta yeniden dene
    throw err;
  });
  return cache;
}

export interface FrameworkSelectProps {
  id: string;
  /** null = çerçevesiz */
  value: string | null;
  /** Setin kayıtlı çerçeve adı — listede yoksa seçenek olarak korunur. */
  currentName?: string | null;
  disabled?: boolean;
  onChange: (next: { id: string | null; name: string | null }) => void;
}

export function FrameworkSelect(props: FrameworkSelectProps): JSX.Element {
  const { id, value, currentName, disabled, onChange } = props;
  const [options, setOptions] = useState<KpiFrameworkOption[] | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadFrameworks()
      .then((list) => {
        if (!cancelled) setOptions(list);
      })
      .catch(() => {
        if (!cancelled) {
          setOptions([]);
          setFailed(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const list = options ?? [];
  const orphan = value && currentName && !list.some((f) => f.id === value) ? value : null;

  return (
    <select
      id={id}
      style={inputStyle}
      value={value ?? ""}
      disabled={disabled === true || options === null}
      aria-busy={options === null ? true : undefined}
      onChange={(e) => {
        const raw = e.target.value;
        const next = raw === "" ? null : raw;
        const found = list.find((f) => f.id === next);
        onChange({
          id: next,
          name: found ? found.name : next === orphan ? (currentName ?? null) : null,
        });
      }}
    >
      <option value="">
        {options === null ? KPI_COPY.framework.loading : KPI_COPY.framework.none}
      </option>
      {orphan ? (
        <option value={orphan}>
          {currentName} {KPI_COPY.framework.notPublished}
        </option>
      ) : null}
      {list.map((f) => (
        <option key={f.id} value={f.id}>
          {f.name}
          {f.currentVersion ? ` (${f.currentVersion})` : ""}
        </option>
      ))}
      {failed ? <option disabled>{KPI_COPY.framework.loadFailed}</option> : null}
    </select>
  );
}
